"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { Navbar } from "@/components/layout/navbar";
import { Footer } from "@/components/layout/footer";
import { FloatingFabricBackground } from "@/components/layout/floating-fabric-background";

interface MainLayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

export function MainLayout({ children, hideFooter = false }: MainLayoutProps) {
  const pathname = usePathname();
  const isHomePage = pathname === "/";

  // Define paths that should have a plain background (like chat)
  const plainBackgroundPaths = [
    "/chat",
    "/profile",
    "/auth",
    "/api-playground",
    "/docs"
  ];

  // Check if current path should have a plain background
  const shouldHavePlainBackground = plainBackgroundPaths.some(path => 
    pathname.startsWith(path)
  );

  return (
    <div className={`flex min-h-screen flex-col relative ${shouldHavePlainBackground ? "bg-background" : ""}`}>
      {/* Only show animated background on home page */}
      {isHomePage && <FloatingFabricBackground />}
      
      {/* Use regular navbar for all pages */}
      <Navbar />
      
      <main className="flex-1 mx-auto w-full">
        {children}
      </main>
      
      {!hideFooter && <Footer />}
    </div>
  );
}
